/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Too_Many_RequestsInputs */

const en_us2_coaching_too_many_requests = /** @type {(inputs: Coaching_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many actions in a short time. Try again later.`)
};

const pt_br2_coaching_too_many_requests = /** @type {(inputs: Coaching_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muitas ações em pouco tempo. Tente de novo mais tarde.`)
};

const pt_pt2_coaching_too_many_requests = /** @type {(inputs: Coaching_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muitas ações em pouco tempo. Tente de novo mais tarde.`)
};

/** @type {(inputs: Coaching_Too_Many_RequestsInputs) => LocalizedString} */
const es_419_coaching_too_many_requests = en_us2_coaching_too_many_requests;

/** @type {(inputs: Coaching_Too_Many_RequestsInputs) => LocalizedString} */
const fr_fr2_coaching_too_many_requests = en_us2_coaching_too_many_requests;

/** @type {(inputs: Coaching_Too_Many_RequestsInputs) => LocalizedString} */
const de_de2_coaching_too_many_requests = en_us2_coaching_too_many_requests;

/** @type {(inputs: Coaching_Too_Many_RequestsInputs) => LocalizedString} */
const it_it2_coaching_too_many_requests = en_us2_coaching_too_many_requests;

/**
* | output |
* | --- |
* | "Too many actions in a short time. Try again later." |
*
* @param {Coaching_Too_Many_RequestsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_too_many_requests = /** @type {((inputs?: Coaching_Too_Many_RequestsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Too_Many_RequestsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_too_many_requests(inputs)
	if (locale === "es-419") return es_419_coaching_too_many_requests(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_too_many_requests(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_too_many_requests(inputs)
	if (locale === "de-DE") return de_de2_coaching_too_many_requests(inputs)
	if (locale === "it-IT") return it_it2_coaching_too_many_requests(inputs)
	return en_us2_coaching_too_many_requests(inputs)
});
export { coaching_too_many_requests as "coaching.too_many_requests" }